// context/ClerkAuthContext.tsx
import React, { createContext, useEffect, useState, useContext } from "react";
import { useUser, useAuth } from "@clerk/clerk-react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { ClerkAuth, userLogout } from "../redux/actions/AuthAction";
import { GetUserProfile } from "../redux/actions/UserAction";
import { GetAllStories } from "../redux/actions/StoryAction";
import { getAllImagesByUser } from "../redux/actions/ImageAction";
import {
  GetCurrentPlan,
  GetUpcommingPlan,
} from "../redux/actions/SubscriptionAction";
const ClerkAuthContext = createContext<any>(null);

export const ClerkAuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user, isSignedIn } = useUser();
  const { getToken } = useAuth();
  const [isSynced, setIsSynced] = useState(false);
  const dispatch = useDispatch();

  const {
    GetUserProfile: getUserProfile,
    GetAllStories: getAllStories,
    getAllImagesByUser: getAllImages,
    GetCurrentPlan: getCurrentPlan,
    GetUpcommingPlan: getUpcomingPlan,
    userLogout: logout,
    ClerkAuth: handleClerkAuth,
  } = bindActionCreators(
    {
      GetUserProfile,
      GetAllStories,
      getAllImagesByUser,
      GetCurrentPlan,
      GetUpcommingPlan,
      userLogout,
      ClerkAuth,
    },
    dispatch
  );

  useEffect(() => {
    const syncWithBackend = async () => {
      if (!isSignedIn || !user) return;

      const token = await getToken();
      const payload = {
        uid: user.id,
        email: user?.primaryEmailAddress?.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
        phoneNumber: user.phoneNumbers[0]?.phoneNumber || "",
      };

      try {
        const response: any = await handleClerkAuth(payload);
        const syncedUser = response.data.user;

        token && localStorage.setItem("authToken", token);
        localStorage.setItem("uid", syncedUser.uid);
        localStorage.setItem("method", "clerk");
        if (response) {
          getUserProfile(syncedUser.uid);
          getAllStories(syncedUser.uid);
          getAllImages(syncedUser.uid);
          getCurrentPlan(syncedUser.uid);
          getUpcomingPlan(syncedUser.uid);
        }
        setIsSynced(true);
      } catch (error) {
        setIsSynced(false);
      }
    };

    syncWithBackend();
  }, [isSignedIn, user]);

  return (
    <ClerkAuthContext.Provider
      value={{
        user,
        isSignedIn,
        isSynced,
        logout,
      }}
    >
      {children}
    </ClerkAuthContext.Provider>
  );
};

export const useClerkAuth = () => useContext(ClerkAuthContext);
